import { observer } from 'mobx-react';
import React from 'react';
import { ImageUpload } from '@components/image-upload';
import LocalizedTextArea from '@components/text-area/localized-text-area';
import LocalizedTextField from '@components/textfield/localized_textfield';
import { getCdnImage } from '@components/utils/cdn-image';
import { injectTSDI } from '@core/tsdi';
import { ChallengeDataStore } from '../data-store';
import { ChallengePresentationStore } from './store';

export const PresentationStep = observer(() => {
    const { disabledPresentationEdit } = injectTSDI(ChallengeDataStore);

    const {
        fields: { prizeDescription, name, photo, resetKey },
        imageUploadRequest,
        imageUploadHandler,
        errors,
        validatePresentation
    } = injectTSDI(ChallengePresentationStore);

    return (
        <div className="flex flex-col gap-6">
            <LocalizedTextField
                type="text"
                label="Event name"
                value={name.value}
                onChange={(value) => {
                    name.onChange(value);
                    validatePresentation(false);
                }}
                disabled={disabledPresentationEdit}
                error={name.error}
                required
                InputLabelShrink
                data-testid="challenge-name-field"
            />
            <ImageUpload
                onUpload={imageUploadHandler}
                loading={imageUploadRequest.loading}
                error={photo.error}
                previewUrl={getCdnImage(
                    photo.value?.bucketName,
                    photo.value?.objectKey
                )}
                label="Community Photo"
                helperText="Drag and drop a community photo here, or click to select"
            />
            <LocalizedTextArea
                label="Event prize"
                onChange={(value) => {
                    prizeDescription.onChange(value);
                    validatePresentation(false);
                }}
                value={prizeDescription.value}
                error={prizeDescription.error}
                disabled={disabledPresentationEdit}
                height={200}
                dataTestId="prize-description-field"
                resetKey={resetKey}
            />
            {errors && (
                <p className="text-right text-sm text-destructive">{errors}</p>
            )}
        </div>
    );
});
